import { ReactNode } from 'react'
import { AlertCircle, Check } from '@stratascratch/icons'
import { cn } from '../lib/utils'
import './Alert.css'

export type AlertType = 'info' | 'success' | 'danger'

interface AlertProps {
  type: AlertType
  noIcon?: boolean
  className?: string
  children: ReactNode
}

function Alert({ type, noIcon = false, className = '', children }: AlertProps) {
  return (
    <div
      className={cn(
        'Alert my-5 flex items-center justify-center gap-2 rounded-sm px-6 py-4 text-center text-sm/5',
        `Alert--${type}`,
        className,
      )}
      role="alert"
    >
      {!noIcon && type === 'success' && (
        <Check className={`Alert__icon Alert__icon--${type}`} />
      )}
      {!noIcon && type === 'danger' && (
        <AlertCircle className={`Alert__icon Alert__icon--${type}`} />
      )}
      {children}
    </div>
  )
}

export default Alert
